import { React } from "react";
import "./App.css";
import CalendarWidget from "./pages/calendar/CalendarWidget";
import TimeSlotWidget from "./pages/time-slot/TimeSlotWidget";
import ConfirmBookingPage from "./pages/confirm-booking-page/ConfirmBookingPage";
import BookingSuccessPage from "./pages/booking-success-page/BookingSuccessPage";
import { Route, Routes } from "react-router-dom";
import LoginPage from "./pages/login-pages/LoginPage";
import Header from "./components/header/Header";
import UserDetailsPage from "./pages/user-details-page/UserDetailsPage";
import ServiceForPage from "./pages/service-for-choice/ServiceForPage";
import PatientRegister from "./pages/patient-registration/PatientRegister";
import ConsultationTypeComponent from "./pages/select-consultation-type/ConsultationTypeComponent";

function App({ children }) {
  return (
    <>
      <Header />
      {children}
      <main>
        <div className="App__multistepform">
          <Routes>
            <Route path="/" element={<LoginPage />} />
            <Route path="/select-slot" element={<TimeSlotWidget />} />
            <Route path="/user-details" element={<UserDetailsPage />} />
            <Route path="/services-for" element={<ServiceForPage />} />
            <Route path="/patient-registration" element={<PatientRegister />} />
            <Route path="/booking-details" element={<ConfirmBookingPage />} />
            <Route path="/calendar" element={<CalendarWidget />} />
            <Route path="/service-for" element={<ServiceForPage />} />
            <Route
              path="/select-consultation-type"
              element={<ConsultationTypeComponent />}
            />
            <Route
              path="/booking-successful"
              element={<BookingSuccessPage />}
            />
          </Routes>
        </div>
      </main>
    </>
  );
}

export default App;
